import type { FaireProductEntity } from "../../entity_types/product";

export const p_mme9k3ufaf: FaireProductEntity = {
  token: "p_mme9k3ufaf",
  type: "product",
  name: "Cotton Blend Loose Knit Hoodie Sweater",
  brandToken: "b_4z8um3dept",
  brandName: "Sheer Trend",
  imageUrl:
    "https://cdn.faire.com/fastly/ac20e8fb5e8ca62d808b12d037d9f4c5736887a11a2f479972a9d032ddcf6163.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/29b43d18223fe942967d3bbc9b4ba6ce7e2b34817f328fe61c153f6daef50009.jpeg",
    "https://cdn.faire.com/fastly/592de627361a376625168bdaf01c8e2e34e83eb4c1a00ff079e4e652b18d19b5.jpeg",
    "https://cdn.faire.com/fastly/b582dacdbe29e7c9ed362e6d1ec1468402e1954dc2529246bec691194a2d04d4.jpeg",
    "https://cdn.faire.com/fastly/2be4950a125d8a1e64cb41bbd66ed63f6381db91cd2b109dd8c245e0acc6ab81.jpeg",
    "https://cdn.faire.com/fastly/3ee862f4c736d81bcd29c54a8ddb3530a26e7dfa43a30d3146efef7399fb65bb.jpeg",
    "https://cdn.faire.com/fastly/f251040f91c4619a2ea7335fe62c71118fd49e76f26c9012c2505e5266eb6b09.jpeg",
    "https://cdn.faire.com/fastly/91fb4a2d9b1f6cc4db69758fe21253a81c6c94b04d230b679279e362d29aebd7.jpeg",
    "https://cdn.faire.com/fastly/8243f43b36b11dd10b0ca027b2a255ba3b16d7a5dc0411458bc128165047116b.jpeg",
    "https://cdn.faire.com/fastly/7c8b5597f94a7a67c97945506108c2237e47683f5c6009f3a273f7128de181ee.jpeg",
    "https://cdn.faire.com/fastly/327181efc816c52318bffeee71127f40de3c4d8af853f94430629a6dcb7c98e2.jpeg",
    "https://cdn.faire.com/fastly/c770aa780ff1041dfddbc14f31db8c1d7463d0a5d83ca05d54e557fbd5e15963.jpeg",
  ],
  priceDollars: 13.99,
  description:
    "Material:Cotton-blend\n\nStyle:Loose\n\nSleeve Length:Long Sleeve\n\nSleeve Style:Raglan Sleeve\n\nDiscover our Cotton Blend Solid Color Loose Knit Hoodie Sweater, crafted from soft cotton-blend fabric for ultimate comfort. This long sleeve hoodie features a relaxed loose fit and stylish raglan sleeves, perfect for casual wear. Ideal for those seeking a cozy, everyday sweater with a modern look. \n\n#cotton blend hoodie, #loose knit sweater, #solid color hoodie, #raglan sleeve sweater, #long sleeve hoodie, #cotton blend sweater, #loose hoodie, #casual knit hoodie, #solid knit sweater, #raglan cotton hoodie,\n",
  tags: [],
  msrpDollars: 27.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:27:10.558Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
